// extracted by mini-css-extract-plugin
export default {"informationcard__card":"DashboardInformation_informationcard__card__R01FN","informationcard__card__item":"DashboardInformation_informationcard__card__item__9QpB1"};